"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _variables = require("../common/variables.js");

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _BackgroundColorContext = require("../BackgroundColorContext");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DxcDialog = function DxcDialog(_ref) {
  var _ref$isCloseVisible = _ref.isCloseVisible,
      isCloseVisible = _ref$isCloseVisible === void 0 ? true : _ref$isCloseVisible,
      onCloseClick = _ref.onCloseClick,
      children = _ref.children,
      _ref$overlay = _ref.overlay,
      overlay = _ref$overlay === void 0 ? true : _ref$overlay,
      onBackgroundClick = _ref.onBackgroundClick,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? "small" : _ref$padding,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex;
  var colorsTheme = (0, _useTheme["default"])();

  var handleClose = function handleClose() {
    onCloseClick === null || onCloseClick === void 0 ? void 0 : onCloseClick();
  };

  var handleOverlayClick = function handleOverlayClick() {
    onBackgroundClick === null || onBackgroundClick === void 0 ? void 0 : onBackgroundClick();
  };

  var handleOnKeyDown = function handleOnKeyDown(event) {
    if (event.key === "Escape") {
      event.preventDefault();
      handleClose();
    }
  };

  (0, _react.useEffect)(function () {
    if (isCloseVisible) {
      window.addEventListener("keydown", handleOnKeyDown);
    }

    return function () {
      window.removeEventListener("keydown", handleOnKeyDown);
    };
  }, [isCloseVisible]);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.dialog
  }, /*#__PURE__*/_react["default"].createElement(BodyStyle, null), /*#__PURE__*/_react["default"].createElement(DialogContainer, {
    role: "presentation"
  }, overlay && /*#__PURE__*/_react["default"].createElement(Overlay, {
    onClick: handleOverlayClick
  }), /*#__PURE__*/_react["default"].createElement(Dialog, {
    role: "dialog",
    "aria-modal": overlay,
    isCloseVisible: isCloseVisible
  }, /*#__PURE__*/_react["default"].createElement(Children, {
    padding: padding
  }, /*#__PURE__*/_react["default"].createElement(_BackgroundColorContext.BackgroundColorProvider, {
    color: colorsTheme.dialog.backgroundColor
  }, children)), isCloseVisible && /*#__PURE__*/_react["default"].createElement(CloseIconContainer, {
    onClick: handleClose,
    tabIndex: tabIndex
  }, /*#__PURE__*/_react["default"].createElement(CloseIcon, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
  }))))));
};

var BodyStyle = (0, _styledComponents.createGlobalStyle)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  body {\n    overflow: hidden;\n  }\n"])));

var DialogContainer = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  inset: 0px;\n  height: 100%;\n  z-index: 1300;\n"])));

var Overlay = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  position: fixed;\n  inset: 0px;\n  height: 100%;\n  background-color: ", ";\n  opacity: ", ";\n"])), function (props) {
  return props.theme.overlayColor;
}, function (props) {
  return props.theme.overlayOpacity;
});

var Dialog = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  justify-content: space-between;\n  z-index: 1300;\n  background-color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  ", "\n  box-sizing: border-box;\n  box-shadow: ", ";\n  border-radius: 4px;\n  position: relative;\n\n  @media (min-width: ", "rem) {\n    max-width: 80%;\n    min-width: 800px;\n  }\n\n  @media (max-width: ", "rem) {\n    //mobile phones\n    max-width: 92%;\n    min-width: 92%;\n  }\n"])), function (props) {
  return props.theme.backgroundColor;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.fontSize;
}, function (props) {
  return props.theme.fontWeight;
}, function (props) {
  return props.isCloseVisible && "min-height: 72px; padding-top: 24px;";
}, function (props) {
  return "".concat(props.theme.boxShadowOffsetX, " ").concat(props.theme.boxShadowOffsetY, " ").concat(props.theme.boxShadowBlur, " ").concat(props.theme.boxShadowColor);
}, _variables.responsiveSizes.medium, _variables.responsiveSizes.medium);

var Children = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: ", ";\n  padding-top: ", ";\n  padding-right: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n"])), function (props) {
  return props.padding && (0, _typeof2["default"])(props.padding) !== "object" ? _variables.spaces[props.padding] : _variables.spaces["small"];
}, function (props) {
  return props.padding && (0, _typeof2["default"])(props.padding) === "object" && props.padding.top ? _variables.spaces[props.padding.top] : "";
}, function (props) {
  return props.padding && (0, _typeof2["default"])(props.padding) === "object" && props.padding.right ? _variables.spaces[props.padding.right] : "";
}, function (props) {
  return props.padding && (0, _typeof2["default"])(props.padding) === "object" && props.padding.bottom ? _variables.spaces[props.padding.bottom] : "";
}, function (props) {
  return props.padding && (0, _typeof2["default"])(props.padding) === "object" && props.padding.left ? _variables.spaces[props.padding.left] : "";
});

var CloseIconContainer = _styledComponents["default"].button(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n  background: none;\n  border: none;\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  color: ", ";\n  width: ", ";\n  height: ", ";\n"])), function (props) {
  return props.theme.closeIconColor;
}, function (props) {
  return props.theme.closeIconWidth;
}, function (props) {
  return props.theme.closeIconHeight;
});

var CloseIcon = _styledComponents["default"].svg(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  background-color: ", ";\n  width: ", ";\n  height: ", ";\n  border-radius: ", ";\n  border-width: ", ";\n  border-style: ", ";\n  border-color: ", ";\n"])), function (props) {
  return props.theme.closeIconBackgroundColor;
}, function (props) {
  return props.theme.closeIconWidth;
}, function (props) {
  return props.theme.closeIconHeight;
}, function (props) {
  return props.theme.closeIconBorderRadius;
}, function (props) {
  return props.theme.closeIconBorderThickness;
}, function (props) {
  return props.theme.closeIconBorderStyle;
}, function (props) {
  return props.theme.closeIconBorderColor;
});

var _default = DxcDialog;
exports["default"] = _default;